import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
} from '@angular/core';
import { BaseFormControl, BaseSignalInput, OverlayService, SignalTextField } from '@vallift/ngl';
import { MapLocationPickerOverlay } from './map-location-picker-overlay/map-location-picker-overlay';
import { ReactiveFormsModule } from '@angular/forms';

export interface MapLocationValue {
  address: string;
  latitude: number;
  longitude: number;
  placeId: string | null;
}

@Component({
  selector: 'app-map-location-picker',
  standalone: true,
  templateUrl: './map-location-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseSignalInput, ReactiveFormsModule, SignalTextField],
})
export class MapLocationPickerComponent extends BaseFormControl<MapLocationValue | null> {
  private readonly overlayService = inject(OverlayService);
  readonly label = input('Location');
  readonly placeholder = input('Search for a location');

  openPicker(): void {
    const dialogRef = this.overlayService.openModal(MapLocationPickerOverlay);
    dialogRef.closed.subscribe((location) => {
      if (location) {
        this.value.set(location);
      }
    });
    dialogRef.updateSize('min(700px, 90vw)');
  }

  get selectedAddress(): string {
    return this.value()?.address || '';
  }
}
